import { getDocumentElement } from "../../Utils/Utils";

/**
 * Calculation for Household Water Use.
 * 
 * Calculation shown below (answer will be in Megalitres)
 * Number of residents x 43,800 litres/person/year ÷ 1,000,000
 * 
 * @param   {HTMLElement}    residents 
 * @param   {HTMLElement}    megLTotal 
 * 
 * @returns {void}
 */
const HouseholdWaterUseCalcHandler = (residents, megLTotal, HouseholdSummaryTotal) => {
    const Value = (residents.value * 43800) / 1000000;
    megLTotal.value = Value.toFixed(3);
    HouseholdSummaryTotal.value = Value.toFixed(3);
};

/**
 * Identify the the household water use fields, and then
 * bind the handler to the event listener.
 * 
 * @returns {void}
 */
export const HouseholdWaterUseCalc = () => {
    const NumberOfResidents = getDocumentElement('#residentNo');
    const MegaLTotal = getDocumentElement('#residentTotal');
    const HouseholdSummaryTotal = getDocumentElement('#tot_resident');

    if (NumberOfResidents && MegaLTotal) {
        NumberOfResidents.addEventListener('input', () => {
            HouseholdWaterUseCalcHandler(NumberOfResidents, MegaLTotal, HouseholdSummaryTotal);
        });
    }
};